module.exports = __webpack_public_path__ + "il.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/il.svg
// module id = 862
// module chunks = 0